import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// global import for symbol ponyfill - Required for React.Fragment usage
import 'es6-symbol';
import Header from './containers/Header/Header';
import Main from './containers/Main';
import Footer from './containers/Footer/Footer';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <div>
    <Header />
    <Main />
    <Footer />
  </div>,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js